/**
 * Created by pmacko on 13.11.2016.
 */

class DataTablesHelper
{
    public static createColumnDefinitionFromTable(table: JQuery)
    {
        let columnData: any[] = [];

        table.find('thead th').each(function(){
            let thisEl = $(this);

            let column:any = {};

            column.data = thisEl.data('column');

            let value = thisEl.data('orderable');

            if(value != null && value != '')
            {
                column.orderable = value;
            }

            value = thisEl.data('classname');

            if(value != null && value != '')
            {
                column.className = value;
            }
            columnData.push(column);
        });

        return columnData;
    }
}